import './Footer.scss';
import logo from '../../img/logo.svg';

const Footer = () => {
    return(
        <section className="Footer">
            <div className="Footer-col-txt">
                <a href="/">
                    <img className="Footer-col-txt-logo" alt='logotype of Indomitus' src={logo}/>
                </a>
                <p className="Footer-link"><a href='https://apps.ucu.edu.ua/'>UCU.APPS</a>, ©2026</p>
            </div>
            <div className="Footer-col-links">
                <a href="/#team" className='Footer-col-links-a'>TEAM</a>
                <a href="/about" className='Footer-col-links-a'>ABOUT</a>
                <a href="/#partners" className='Footer-col-links-a'>PARTNERS</a>
                <a href="/#contact-us" className='Footer-col-links-a'>CONTACT US</a>
            </div>
            <div className="Footer-col-reach">
                <p className='Footer-col-reach-p'>
                    DO YOU HAVE QUESTIONS? <br/>
                    WE HAVE ANSWERS! 
                </p>
                <a className='Footer-col-reach-a' href="mailto:indomitus@ucu.edu.ua">
                    indomitus@ucu.edu.ua
                </a>
            </div>
            <div className="Footer-tag">
                <p className="Footer-link"><a href='https://apps.ucu.edu.ua/'>UCU.APPS</a>, ©2026</p>
            </div>
        </section>
    )
}
export default Footer;